import { render } from "./DebugAccessView.vue?vue&type=template&id=5f1a8d16&scoped=true"
import script from "./DebugAccessView.vue?vue&type=script&lang=js"
export * from "./DebugAccessView.vue?vue&type=script&lang=js"

import "./DebugAccessView.vue?vue&type=style&index=0&id=5f1a8d16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1a8d16"]])

export default __exports__